import React, {useState, useEffect} from 'react'

//local sections below
import Aortic from "./Aortic";
import Mitral from "./Mitral";
import InvasiveInstruments from './InvasiveInstruments';
import Info from "./Info";
//local sections above

//footer component
import Footer from "../../components/Footer"
import PopUpDisclaimer from "../../components/PopUpDisclaimer/"
import { Link } from 'react-router-dom';
import SelectionOnDevices from './DeviceSelection';
//footer component

// constants import
import { US, OUT_OF_US } from '../../constants';
// constants import



const Devices = () => {
    const [showLegal, setShowLegal] = useState(true);
    const handleChange = (e) => {
        setShowLegal(false);

        //activate all links
        let pageLinks = document.querySelectorAll(".pageDevice a");
        for (let i = 0; i < pageLinks.length; i++) 
        {
            pageLinks[i].style.pointerEvents = null;
        }

        // document.body.classList.remove("blurr");
        // document.body.style.overflowY = "auto";
        localStorage.setItem("devices", true);
    } 
    
    const [selection, setSelection] = useState(US);

    useEffect(() => {
        // show legel code
        if(localStorage.getItem("devices") && localStorage.getItem("devices") != 'false'){
            setShowLegal(false);
        } else{
            // document.body.classList.add("blurr");
            // document.body.style.overflowY = "hidden";

            //disable all links
            let pageLinks = document.querySelectorAll(".pageDevice a");
            for (let i = 0; i < pageLinks.length; i++) 
            {
                pageLinks[i].style.pointerEvents = 'none';
            }
        }
        // show legel code

        // set default Us devices 
        if(typeof localStorage.getItem("main_page_selection") == "undefined" || (localStorage.getItem("main_page_selection") != US && localStorage.getItem("main_page_selection") != OUT_OF_US))
        {
            localStorage.setItem("main_page_selection", US);
        }
        else
        {
            setSelection(localStorage.getItem("main_page_selection"));
        }
    }, [])

    return (
        <div className="h-full flex flex-col navbar-padding">

        {showLegal ?
            <PopUpDisclaimer handleChange={handleChange}/>
        : null}

            <div className={`flex-grow ${showLegal ? 'opacityPopUpDisclaimer' : ''} pageDevice`}>
                {/* container heading start */}
                {/* <div className = "-mt-4 2xl:-mt-16 px-10 pb-10">
                    <p className = "text-gray-text text-sm text-center">By continuing in this section, you acknowledge that you are a Healthcare Professional.</p>
                </div> */}
                
                {/* Selection */}
                <SelectionOnDevices selection={selection} setSelection={setSelection} />
                {/* Selection */}
                <div className="block md:flex items-center w-full">
                    <div className="py-4 w-full pl-10 xl:pl-20 md:w-1/4 lg:h-full bg-white">
                        <h6 className="uppercase font-medium text-base 2xl:text-lg text-blue-primary">
                            Devices
                        </h6>
                    </div>
                    {/* container design start */}
                    <div className="hidden md:block md:w-3/4 md:h-12 bg-repeat-x bg-contain" style={{backgroundImage: "url(/images/pattern.svg)"}}>
                        
                    </div>
                    {/* container design end */}
                </div>
                {/* container heading end */}

                {/* aortic section */}
                <Aortic /> 
                
                {/* section divider start */}
                <div className="hidden lg:block bg-white h-8 w-1/4"></div>
                {/* section divider end */}

                {/* mitral section */}
                <Mitral />
                {/* section divider start */}
                <div className="hidden lg:block bg-white h-8 w-1/4"></div>
                {/* section divider end */}


                {/* invasive section */}
                {
                    selection === US?
                    <InvasiveInstruments />
                    :
                    null
                }

                {/* info section */}
                <Info />
            </div>

            <Footer color=""/>
        
        </div>
    )
}

export default Devices
